const FLAG_URL_SWEDISH = 'https://cdn.shopify.com/s/files/1/0868/3094/0479/files/Sweden_flag_square.png?v=1743168952';
const FLAG_URL_ENGLISH = 'https://cdn.shopify.com/s/files/1/0868/3094/0479/files/United_Kingdom_flag_square.png?v=1743168952';
const EN_VALUE = 'en';
const SWE_VALUE = 'sv';

function getForm(){
  return document.querySelector('#HeaderLanguageForm');
}

function hideForm(form){
  form.style.display = 'none';
}

function getLanguageElements(){
  const object = {}
  
  const languageElements = document.querySelectorAll('#HeaderLanguageList .disclosure__item a');
  var swedishLanguageElement = null;
  var englishLanguageElement = null;
  languageElements.forEach(a => {
    const lang = a.getAttribute('lang');
    const hreflang = a.getAttribute('hreflang');
    if(lang == EN_VALUE || hreflang == EN_VALUE){
      englishLanguageElement = a;
    }
    else if(lang == SWE_VALUE || hreflang == SWE_VALUE){
      swedishLanguageElement = a;
    }
  });
  if(swedishLanguageElement == null || englishLanguageElement == null){
    return null;
  }
  object.swedish = swedishLanguageElement;
  object.english = englishLanguageElement;
  return object;
}

function replaceFlags() {
  const form = getForm();
  if(!form){
    console.log("failed to find langauge form.");
  }
  const languageElements = getLanguageElements();
  if(!languageElements){
    console.log("failed to find langauge links.");
  }
  
  const swedish = Shopify.locale === SWE_VALUE;
  const langaugeElement = swedish ? languageElements.english : languageElements.swedish;
  const flag = swedish ? FLAG_URL_SWEDISH : FLAG_URL_ENGLISH;
  const altText = swedish ? 'English' : 'Svenska';
  const parent = form.parentNode.parentNode;

  let div = document.createElement('div');
  div.id = 'language-flag';
  div.style = "margin-bottom: auto; margin-top: auto; align-content: center;";

  const aStyle = 'display: flex;';
  const imgStyle = 'max-height: 25px; padding-left:15px; padding-right: 15px;';
  div.innerHTML = 
    '<a style="' + aStyle +'" class="language-flag-link" href="#">' + '\n' +
      '<img style="' + imgStyle + '" class="language-flag-image" src="' + flag + '" alt="' + altText + '">' + '\n' + 
      '</img>' + '\n' +
    '</a>' + '\n';
  
  parent.insertBefore(div, form.parentNode);

  document.querySelector('#language-flag .language-flag-link') 
    .addEventListener('click', function() {
      langaugeElement.click();
    });
  
  hideForm(form);
}

document.addEventListener('DOMContentLoaded', replaceFlags);
